<script>
  import {list, schema as getScheam, createRecord, updateRecord, removeRecord} from "../../modules/api-client";
  import Cell from "./cell.svelte";

  export let table;
  export let filter;
  export let disable;
  export let sort;

  const disableOptions = disable?.split(',') || [];

  let schema = {};
  let cols = [];
  let rows = [];
  let originalRows = [];
  let rowsIndex = {};
  let newRecord = {};

  function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  function refresh() {
    //rows = [...rows];
  }

  function refreshIndex() {
    rowsIndex = rows.reduce((obj, r, i) => ({...obj, [r._id]: i}), {});
  }

  async function configure() {
    schema = await getScheam(table);
    rows = await list(table, filter, sort, ['*']);
    refreshIndex();
    originalRows = clone(rows);
    cols = Object.keys(schema);
  }

  configure();
  $: filter, configure();

  async function update(record) {
    console.log(JSON.stringify(record));
    const fields = record.changed.reduce((obj, field) => ({...obj, [field]: record[field]}), {});
    console.log(fields);
    await updateRecord(table, record._id, fields);
    const i = rowsIndex[record._id];
    originalRows[i] = clone(record);
    seeChanges();
  }

  async function remove(row) {
    const index = rowsIndex[row._id];
    if (!row.removing) {
      row.removing = true;
      rows = clone(rows);
      setTimeout(() => {
        console.log('stop removing')
        rows[index].removing = false;
      }, 2000);
    } else {
      await removeRecord(table, row._id);
      rows = [...rows.slice(0, index), ...rows.slice(index + 1)];
      originalRows = [...originalRows.slice(0, index), ...originalRows.slice(index + 1)];
      refreshIndex();
    }
  }

  async function cancel({_id}) {
    const index = rowsIndex[_id];
    rows[index] = clone(originalRows[index]);
  }

  async function create() {
    console.log('creating', newRecord);
    const record = await createRecord(table, newRecord);
    rows = [...rows, record];
    originalRows.push(clone(record));
    newRecord = {};
    refreshIndex();
  }

  function isEqual(rowElement, originalRowElement, schemaElement) {
    if (schemaElement.ref) {
      return rowElement?._id === originalRowElement?._id
    }
    return rowElement === originalRowElement;
  }

  function seeChanges() {
    console.log('seeing changes')
    for (const i in rows) {
      rows[i].changed = [];
      for (const col of cols) {
        if (!isEqual(rows[i][col], originalRows[i][col], schema[col])) {
          rows[i].changed.push(col);
          console.log(col, rows[i][col], 'original', originalRows[i][col]);
        }
      }
    }
    refresh();
  }

  $: rows, seeChanges();
</script>


<div class="container-fluid">
    <div class="card shadow mb-4">
        <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary title">{table}</h6>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr class="title">
                        {#each cols as col}
                            <th scope="col">
                                {col}
                                {#if sort?.[col]}
                                    <i class="bi bi-caret-{sort[col] > 0 ? 'up' : 'down'}"></i>
                                {/if}
                            </th>
                        {/each}
                        <th>: )</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each rows as row}
                        <tr class="{row.changed.length > 0 ? 'table-danger' : ''}">
                            {#each cols as col}
                                <td>
                                    <Cell bind:value={row[col]} type={schema[col]}/>
                                </td>
                            {/each}
                            <td>
                                <a href="javascript:;" on:click={() => update(row)}><i
                                        class="bi bi-check-circle"></i></a>
                                <a href="javascript:;" on:click={() => cancel(row)}><i class="bi bi-x-circle"></i></a>
                                <a href="javascript:;" on:click={() => remove(row)}><i
                                        class="bi {row.removing ? 'bi-exclamation-triangle' : 'bi-dash-circle'}"></i></a>
                            </td>
                        </tr>
                    {/each}
                    {#if !disableOptions.includes('create')}
                        <tr class="table-secondary">
                            {#each cols as col}
                                <td>
                                    <Cell bind:value={newRecord[col]} type="{schema[col]}"/>
                                </td>
                            {/each}
                            <td><a href="javascript:;" on:click={create}><i class="bi bi-plus-circle"></i></a></td>
                        </tr>
                    {/if}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<!-- /.container-fluid -->

<style>
    .title {
        text-transform: capitalize;
    }
</style>